module.exports = "/img/service-4.edf902ba.png";